<!--
 * @FilePath: Editor.vue
 * @Author: chenwei
 * @Date: 2022-04-29 10:03:23
 * @LastEditors: chenwei
 * @LastEditTime: 2022-07-15 10:12:37
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
-->
<template>
    <div style="border: 1px solid #ccc;">
        <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            style="height: 500px; overflow-y: hidden;"
            v-model="html"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
        />
    </div>
</template>

<script>
import Vue from 'vue'
import '@wangeditor/editor/dist/css/style.css'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { proxyHeader } from "@/utils/config"

export default Vue.extend({
    components: { Editor, Toolbar },
    props:["outHtml"],
    data() {
        return {
            editor: null,
            html: '',
            toolbarConfig: { 
                excludeKeys:['uploadVideo'],
            },
            editorConfig: { 
                placeholder: '请输入内容...' ,
                MENU_CONF:{
                    uploadImage:{
                        fieldName: 'file',
                        server:proxyHeader+'service/media-service/media/uploadRichText',
                        headers: {
                            "X-Access-Token": sessionStorage['Access-Token']
                        },
                    },
                }
            },
            mode: 'defualt', // or 'simple'
        }
    },
    methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
    },
    watch:{
        html(val){
            this.$bus.$emit('EditValueGet',val)
        }
    },
    mounted() {
        console.log('init editor');
        setTimeout(() =>{
            this.html = this.outHtml
        },500)
    },
    created(){
        this.$bus.$on("EditValueClear", () => {
            this.html = ''
        });
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
})
</script>

<style>

</style>